import App from "./App";
import { ConfigProvider } from "./app/context/Config/configContext";
import { DirectionProvider } from "./app/context/Direction";
import { LoginModalProvider } from "./app/context/LoginModal";
import { NotificationProvider } from "./app/context/Notification";
import { SoundProvider } from "./app/context/Sound/SoundProvider";
import { CartProvider } from "./app/context/Cart/CartContext";
import { ThemeProvider } from "./app/context/Theme";
import { UploadProvider } from "./app/context/Upload/UploadContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import "font-awesome/css/font-awesome.min.css";
import React from "react";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <ConfigProvider>
        <UploadProvider>
          <DirectionProvider>
            <LoginModalProvider>
              <NotificationProvider>
                <SoundProvider>
                  <CartProvider>
                    <App />
                  </CartProvider>
                </SoundProvider>
              </NotificationProvider>
            </LoginModalProvider>
          </DirectionProvider>
        </UploadProvider>
      </ConfigProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
